import React, { useEffect, useState, useMemo } from "react";
import axios from "axios";
import { useAuth } from "../../Context/AuthContext";
import { Base_URL } from "../../url";
 import { getCompanyByOrganisationId } from "../../Api/IncomingPo";
import "../../Styling/resourceLedger.css";
import { FaFileExcel, FaFilePdf, FaFilter } from "react-icons/fa";
import jsPDF from "jspdf";
import "jspdf-autotable";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

const ResourceLedger = () => {
  const { user, token } = useAuth();

  const [ledgerData, setLedgerData] = useState([]);
  const [openingBalance, setOpeningBalance] = useState(0);
  const [closingBalance, setClosingBalance] = useState(0);

  const [companyList, setCompanyList] = useState([]);

  // 🔹 Filters
  const [orgId, setOrgId] = useState(user?.organisationId || "");
  const [companyCode, setCompanyCode] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  const [loading, setLoading] = useState(false);
  const [resourceList, setResourceList] = useState([]);
const [selectedResource, setSelectedResource] = useState(""); // resourceId

// Load resources based on OrgId
useEffect(() => {
  if (!orgId) return;

  const fetchResources = async () => {
    try {
      const res = await axios.get(`${Base_URL}/AllLeger/GetResourcesByOrg`, {
         params: { orgId: orgId },
        headers: { Authorization: `Bearer ${token}` },
      });
       console.log( res ,"sjdbjd");
      setResourceList(res.data || []);
    } catch (err) {
      console.error("Error fetching resources:", err);
    }
  };

  fetchResources();
}, [orgId, token]);


  // 🔹 Load company codes
  useEffect(() => {
    if (!user?.organisationId) return;
   getCompanyByOrganisationId(user.organisationId).then((res) =>
      setCompanyList(res || [])
    );
  }, [user?.organisationId]);

  // 🔹 Apply Filter API call
  const fetchLedger = async () => {
    if (!orgId) return;

    setLoading(true);
    try {
      const res = await axios.get(
        `${Base_URL}/AllLeger/resource-ledger`,
        {
          params: {
            orgId,
            companyCode: companyCode || null,
             resourceId: selectedResource || null, 
            fromDate: fromDate || null,
            toDate: toDate || null
          },
          headers: { Authorization: `Bearer ${token}` }
        }
      );

      setLedgerData(res.data.ledgerRows || []);
      setOpeningBalance(res.data.openingBalance || 0);
      setClosingBalance(res.data.closingBalance || 0);
    } catch (err) {
      console.error("Ledger error:", err);
    } finally {
      setLoading(false);
    }
  };

  // 🔹 Clear
  const clearFilters = () => {
    setCompanyCode("");
    setFromDate("");
    setToDate("");
    setLedgerData([]);
    setOpeningBalance(0);
    setClosingBalance(0);
  };

  // 🔹 Grid rows with opening & closing
  const tableRows = useMemo(() => {
    if (ledgerData.length === 0) return [];

    const rows = [];

    // 🔹 Opening row
    rows.push({
      type: "OPENING",
      date: fromDate || ledgerData[0]?.date,
      closingBalance: openingBalance
    });

    // 🔹 Transaction rows
    ledgerData.forEach((tx) => rows.push({ ...tx, type: "TX" }));

    // 🔹 Closing row
    rows.push({
      type: "CLOSING",
      date: toDate || ledgerData[ledgerData.length - 1]?.date,
      closingBalance: closingBalance
    });

    return rows;
  }, [ledgerData, openingBalance, closingBalance, fromDate, toDate]);

  // 🔹 Excel
  const downloadExcel = () => {
    const data = tableRows.map((r) => ({
      Date: r.date?.split("T")[0],
      DocumentNo: r.type === "TX" ? r.documentNo : "",
      ItemRef: r.type === "TX" ? r.itemRefNo : "",
      Description:
        r.type === "OPENING"
          ? "Opening Balance"
          : r.type === "CLOSING"
          ? "Closing Balance"
          : r.transactionDescription,
      Debit: r.debit || "",
      Credit: r.credit || "",
      Balance: r.closingBalance
    }));

    const ws = XLSX.utils.json_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Ledger");
    const buf = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    saveAs(new Blob([buf]), "Resource_Ledger.xlsx");
  };


  const downloadPDF = () => {
    const doc = new jsPDF("l", "mm", "a4");

    doc.autoTable({
      head: [[
        "Date", "Doc No", "Item Ref", "Description",
        "Debit", "Credit", "Balance"
      ]],
      body: tableRows.map((r) => [
        r.date?.split("T")[0],
        r.type === "TX" ? r.documentNo : "",
        r.type === "TX" ? r.itemRefNo : "",
        r.type === "OPENING"
          ? "Opening Balance"
          : r.type === "CLOSING"
          ? "Closing Balance"
          : r.transactionDescription,
        r.debit || "",
        r.credit || "",
        r.closingBalance
      ]),
      styles: { fontSize: 8 }
    });

    doc.save("Resource_Ledger.pdf");
  };

  return (
    <div className="ledger-container">
      <h2>Resource Ledger</h2>

      {/* 🔹 Filters */}
      <div className="filters-section">
        <div className="filters-header">
          <FaFilter /> Filters
          <button className="btn-clear" onClick={clearFilters}>Clear</button>
        </div>

        <div className="ledger-filters">
          <input
            type="number"
            placeholder="Organisation ID"
            value={orgId}
            onChange={(e) => setOrgId(e.target.value)}
            className="filter-input"
          />

          <select
            value={companyCode}
            onChange={(e) => setCompanyCode(e.target.value)}
            className="filter-select"
          >
            <option value="">All Companies</option>
            {companyList.map((c, i) => (
              <option key={i} value={c.companyCode}>
                {c.name} - {c.companyCode}
              </option>
            ))}
          </select>

          <input
            type="date"
            value={fromDate}
            onChange={(e) => setFromDate(e.target.value)}
            className="filter-input"
          />

          <input
            type="date"
            value={toDate}
            onChange={(e) => setToDate(e.target.value)}
            className="filter-input"
          />
          <select
  value={selectedResource}
  onChange={(e) => setSelectedResource(e.target.value)}
  className="filter-select"
>
  <option value="">All Resources</option>
  {resourceList.map((r) => (
    <option key={r.resourceId} value={r.resourceId}>
      {r.resourceName} -  ({r.resourceId})
    </option>
  ))}
</select>
          <button className="btn btn-primary" onClick={fetchLedger}>
            Apply Filter
          </button>
        </div>
      </div>

      {/* 🔹 Actions */}
      <div className="header-actions">
        <button onClick={downloadExcel}><FaFileExcel /> Excel</button>
        <button onClick={downloadPDF}><FaFilePdf /> PDF</button>
      </div>

      {/* 🔹 Table */}
      <table className="ledger-table">
        <thead>
          <tr>
            <th>Date</th>
            <th>Doc No</th>
            <th>Item Ref</th>
            <th>Description</th>
            <th>Debit</th>
            <th>Credit</th>
            <th>Balance</th>
          </tr>
        </thead>
        <tbody>
          {loading ? (
  <tr className="loading">
    <td colSpan="7">
      <div className="loading-spinner">
        <div className="spinner"></div>
        <span>Loading ledger data...</span>
      </div>
    </td>
  </tr>
) :  (
            tableRows.map((r, i) => (
              <tr key={i}>
                <td>{r.date?.split("T")[0]}</td>
                <td>{r.type === "TX" ? r.documentNo : ""}</td>
                <td>{r.type === "TX" ? r.itemRefNo : ""}</td>
                <td>
                  {r.type === "OPENING"
                    ? "Opening Balance"
                    : r.type === "CLOSING"
                    ? "Closing Balance"
                    : r.transactionDescription}
                </td>
                <td>{r.debit || ""}</td>
                <td>{r.credit || ""}</td>
                <td>{r.closingBalance}</td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};

export default ResourceLedger;
